import httpService from "Root/api/httpService";
import posthog from "posthog-js";
// ALL AB TEST NAMES GO HERE
// and should be synced between nextjs and reactjs
export const AB_CHECKOUT_BULLET_POINTS = "checkout-bullet-points";
export const AB_CRO_HERO = "cro-hero";
const PREFIX = "AB_TEST_VARIANT/";
const OVERRIDE_DICT = "AB_TEST_OVERRIDE_DICT";
export const trackVariant = (name, variant) => {
    const key = PREFIX + name;
    if (!sessionStorage.getItem(key)) {
        posthog.capture("AB_TEST", { $set_once: { [name]: variant } });
        sessionStorage.setItem(key, variant);
    }
};
async function getTestVariant(name) {
    // first see if there's a manual override
    const manualOverridesJsonString = sessionStorage.getItem(OVERRIDE_DICT);
    const manualOverrides = manualOverridesJsonString ? JSON.parse(manualOverridesJsonString) : {};
    if (manualOverrides[name]) {
        return manualOverrides[name];
    }
    // then see if we've cached the value
    const itemKey = PREFIX + name;
    const cachedValue = sessionStorage.getItem(itemKey);
    if (cachedValue) {
        return cachedValue;
    }
    //   finally, call the server
    try {
        // cache the value and return the result
        const response = await httpService.get(`/api/get-ab-test/?name=${name}`);
        if (response.result) {
            sessionStorage.setItem(itemKey, response.result);
            trackVariant(name, response.result);
            return response.result;
        }
    }
    catch (e) {
        console.error(e);
    }
    return null;
}
export const setOverrideVariant = (name, val) => {
    const manualOverridesJsonString = sessionStorage.getItem(OVERRIDE_DICT);
    const manualOverrides = manualOverridesJsonString ? JSON.parse(manualOverridesJsonString) : {};
    manualOverrides[name] = val;
    sessionStorage.setItem(OVERRIDE_DICT, JSON.stringify(manualOverrides));
};
export const setAllOverrideVariants = (newValues) => {
    sessionStorage.setItem(OVERRIDE_DICT, JSON.stringify(newValues));
};
export const getOverrideVariants = () => {
    const manualOverridesJsonString = sessionStorage.getItem(OVERRIDE_DICT);
    const manualOverrides = manualOverridesJsonString ? JSON.parse(manualOverridesJsonString) : {};
    return manualOverrides;
};
export const isTestVariant = async (name, variant) => {
    const response = await getTestVariant(name);
    return response === variant;
};
export default getTestVariant;
